import React, { useState, useEffect } from "react";
import {
  Table,
  Form
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { searchMultiFunction, toastSuccess } from "../Utility/function";
import { colors } from "../configs";
import { BrowserRouter as Router, Routes, Route, Link, Navigate, Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Modal_Loading } from "../modal";
import { addShopId } from "../redux/authSlice";
import { useTranslation } from 'react-i18next';
import {useParams} from "react-router-dom";
import { fetchNormalShop, fetchNormalShopFranchise } from "../redux/shopSlice";
import { db } from "../db/firestore";
import { OneButton } from "../components";

const { white } = colors;

function FranchiseListScreen() {
    const { docId } = useParams();
    const { currentShopId } = useSelector(state=>state.auth)
    const { shopFranchises } = useSelector(state=>state.shop)
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [search, setSearch] = useState('')
    const [display, setDisplay] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        let arr = shopFranchises
        if(search){
            arr = searchMultiFunction(shopFranchises,search,['name'])
        }
        setDisplay(arr)
    },[search,shopFranchises])

    useEffect(()=>{
        fetchShop(docId)
        
    },[]);

    async function fetchShop(franchiseId){
        setLoading(true);
        try {
            const querySnapshot = await db.collection('shop').where('franchiseId','==',franchiseId).get();
            const data = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));

            const findCurrentShop = data.find(a=>a.id===currentShopId);
            if(findCurrentShop){
                backToShop(findCurrentShop)
            }
            dispatch(fetchNormalShopFranchise(data))
        } catch (error) {
            alert(error)
        } finally {
            setLoading(false)
        }
    }

    async function backToShop(data){
        setLoading(true);
        try {
            const shopDoc = await db.collection('shop').doc(data.id).get();
            const shopData = {
                ...shopDoc.data(),
                id:shopDoc.id,
            };
            dispatch(fetchNormalShop(shopData));
            dispatch(addShopId({
                currentShopId:data.id,
                franchiseDisplay:true
            }))
            toastSuccess('เข้าสู่ระบบสำเร็จ')
            navigate('/master');
            
        } catch (error) {
            alert(error)
        } finally {
            setLoading(false)
        }
        
    }
    
  return (
    <div style={styles.container} >
        <Modal_Loading show={loading} />
        <div style={styles.container6} >
            <h1>สาขาแฟรนไชส์</h1>
        </div>
        <Form.Control 
            type="search" 
            placeholder='ค้นหาด้วยชื่อสาขา'
            onChange={(event)=>{setSearch(event.target.value)}}
            value={search}
            name='ค้นหา'
        />
        &emsp;
        <h4>ค้นพบ {display.length} สาขา</h4>
        <Table striped bordered hover responsive  variant="light" style={{marginLeft:'1rem'}}  >
                  
        <thead  >
            <tr>
                <th style={styles.container2} >{t('reportCategory.no')}</th>
                <th style={styles.container3} >รหัสสาขา</th>
                <th style={styles.container4} >สาขา</th>
                <th style={styles.container4}>ที่ตั้ง</th>
                <th style={styles.container3}>ดูรายงาน</th>
            </tr>
        </thead>
        <tbody  >
            {display.map((item, index) => (
                <tr   key={index} >
                    <td style={styles.container5} >{index+1}.</td>
                    <td style={styles.container5}  >{item.franchiseBranch}</td>
                    <td  >{item.name}</td>
                    <td style={styles.container5} >{item.address}</td>
                    <td style={styles.container5} >
                        <OneButton {...{ text:'รายงานแอปดำ', submit:()=>{backToShop(item)} }} />
                    </td>
                </tr>
            ))}
        </tbody>
        </Table>
    </div>
  );
};

const styles = {
    container : {
        minHeight:'100vh', padding:'1rem'
    },
    container2 : {
        width:'10%', minWidth:'70px', textAlign:'center'
    },
    container3 : {
        width:'15%', minWidth:'150px', textAlign:'center'
    },
    container4 : {
        width:'25%', minWidth:'250px', textAlign:'center'
    },
    container5 : {
        textAlign:'center'
    },
    container6 : {
        backgroundColor:white,display:'flex',justifyContent:'center'
    }
}

export default FranchiseListScreen;
